import { IntelligenceScreen } from '../features/console';

export function ReportPage() {
  return <IntelligenceScreen />;
}
